export enum OveragesTypeEnum {
    HardOverage = "HardOverage",
    SoftOverage = "SoftOverage"
  }